
const fa = {
	copyright: 'Copyright ',
	designedAndDevelopedBy : 'designed & developed by ',

	submit: 'ثبت',
	back: 'بازگشت',
	cancel: 'انصراف',
	ok: 'تایید',
	clear: 'پاک کردن',
	to: 'تا',
	add: 'جدید',
	month: 'ماه',
	view: 'مشاهده',
	rial: ' ریال',
	noAddiction: 'عدم اعتیاد',
	informationCompletionGuide: 'راهنمای تکمیل اطلاعات',
	editTheDocument: 'ویرایش مدرک ',
	dashboard: 'کارتابل',
	customerCount: 'تعداد مشتریان:',
	numberGuaranteesNearMaturity: 'تعداد ضمانت‌نامه‌های نزدیک به سررسید:',
	rulesAndRegulations: 'قوانین و مقررات کارگروه',
	ongoingFiles: 'پرونده‌های در انتظار اقدام',
	support: 'پشتیبانی',
	today: 'امروز:',
	servicesManagement: 'مدیریت خدمات',
	allServices: 'همه خدمات',
	myService: 'خدمات من',
	servicesArchive: 'آرشیو خدمات',
	setting: 'تنظیمات',
	documents: 'مدارک',
	loan: 'تسهیلات',
	bill: 'صورت حساب',
	adequacyCapital: 'کفایت سرمایه',
	fundManagementPanel: 'پنل مدیریتی صندوق',
	warranty: 'ضمانت‌نامه',
	evaluation: 'ارزیابی',
	inbox: 'صندوق دریافت',
	protest: 'اعتراض',
	protestToEnactment: 'اعتراض به مصوبه',
	downloadExcelNotice: 'توجه داشته باشید اکسل دانلود شده شامل محتوایی است که شما در حال مشاهده آن می‌باشید.',
	getExcel: 'دریافت اکسل',
	date: 'تاریخ',
	dateIsNotEntered: 'تاریخ وارد نشده است',
	noDescription: 'توضیحاتی وارد نشده است',
	enterUserName: 'نام کاربری وارد کنید',
	enterPassword: 'کلمه عبور را وارد کنید',
	selectGender: 'جنسیت را انتخاب کنید',
	enterDate: 'تاریخ را انتخاب کنید',
	acceptRules: 'قوانین را تایید کنید',
	closedTickets: 'تیکت‌های بسته شده',
	userName: 'نام کاربری',
	user: 'کاربر',
	password: 'رمز عبور',
	active: 'فعال',
	gender: 'جنسیت',
	male: 'مرد',
	female: 'زن',
	married: 'متاهل',
	single: 'مجرد',
	status: 'وضعیت',
	approved: 'تایید شده',
	reject: 'رد',
	rejected: 'رد شده',
	rejectionAndConfirmationHistory: 'تاریخچه رد و تاییدها',
	documentRejection: 'رد مدرک',
	documentRejectionReason: 'دلیل رد مدرک',
	pleaseEnterRejectReason: 'لطفا دلایل رد مدرک را وارد نمایید',
	subject: 'موضوع',
	priority: 'اولویت',
	title: 'عنوان',
	customerName: 'نام مشتری',
	low: 'کم',
	medium: 'متوسط',
	high: 'زیاد',
	archive: 'آرشیو',
	current: 'در جریان',
	ongoing: 'در تعهد',
	applicant: 'درخواست‌دهنده',
	nationalId: 'شناسه ملی',
	requestNumber: 'شماره پرونده',
	serviceType: 'نوع خدمت',
	warrantyCommandType: 'دستور خدمت',
	lastUpdateTime: 'زمان بروزرسانی',
	contractNumber: 'شماره قرارداد',
	amount: 'مبلغ',
	requestedAmount: 'مبلغ درخواستی',
	requestStatus: 'وضعیت پرونده',
	calculatingBasisDate: 'تاریخ مبنای محاسبات',
	paymentStepsCount: 'تعداد مراحل پرداخت',
	source: 'منبع',
	tender: 'شرکت در مناقصه / مزایده',
	prepaidContract: 'پیش پرداخت قرارداد',
	goodFulfillmentOfObligations: 'حسن انجام تعهدات / حسن اجرای تعهدات',
	credit: 'تعهد پرداخت',
	vajhoZeman: 'استرداد کسور وجه الضمان (حسن انجام کار)',
	warrantyRequest: 'صدور',
	extend: 'تمدید',
	nokul: 'نکول',
	reduction: 'تقلیل',
	custom: 'گمرکی',
	endDate: 'تاریخ پایان',
	warrantyDays: 'تعداد روز ضمانت‌نامه',
	technical: 'فنی',
	financial: 'مالی',
	other: 'سایر',
	waitingForResponse: 'در انتظار پاسخ',
	hasBeenResponded: 'پاسخ داده شده',
	registrationDate: 'زمان ثبت',
	search: 'جستجو',
	getCompleteExcel: 'دریافت اکسل کامل',
	searchTicketsByType: 'در نوع تیکت ها جستجو کنید',
	documentsGroup: 'گروه مدرک',
	capitalAdequacy: 'کفایت سرمایه',
	download: 'دانلود',
	columns: 'ستون‌ها',
	column: 'ستون',
	send: 'ارسال',
	serviceSheets: 'کاربرگ خدمات',
	guarantorsObligations: 'تعهدنامه ضامنین',
	loanRateCalculation: 'محاسبه نرخ تسهیلات',
	loanSetting: 'تنظیمات تسهیلات',
	loanCalculation: 'محاسبه تسهیلات',
	validationAPI: 'API اعتبارسنجی',
	registerAPI: 'API ثبتی',
	recordsList: 'لیست سوابق',
	automatic: 'اتوماتیک',
	manual: 'دستی',
	customerManagement: 'مدیریت مشتریان',
	authManagement: 'مدیریت کاربران',
	usersManagement: 'لیست کاربران',
	rolesManagement: 'لیست نقش‌ها',
	requestDate: 'تاریخ درخواست',
	warrantyNumber: 'شماره ضمانت‌نامه',
	provider: 'ارائه‌دهنده',
	recieveSampleFile: 'دریافت فایل نمونه',
	operation: 'عملیات',
	all: 'همه',
	recieveBlackList: 'دریافت لیست سیاه',
	usersCount: 'تعداد کاربران',
	creationDate: 'تاریخ ایجاد',
	newRoleCreation: 'ایجاد نقش جدید',
	users: 'کاربران',
	mobileNumber: 'شماره موبایل',
	knowledgeBase: 'دانش‌بنیان',
	parkMembership: 'عضویت در پارک',
	memberofTechPark: 'عضو پارک فناوری',
	blackListStatus: 'وضعیت در لیست سیاه',
	connector: 'رابط',
	province: 'استان',
	logo: 'نشان',
	nonActive: 'غیرفعال',
	newUserCreation: 'ایجاد کاربر جدید',
	usersStatus: 'وضعیت کاربران',
	membershipType: 'نوع عضویت',
	telephone: 'تلفن',
	membership: 'عضویت',
	birthPlace: 'محل تولد',
	answered: 'پاسخ داده شده',
	waitingForAnswer: 'در انتظار پاسخ',
	individual: 'حقیقی',
	legal: 'حقوقی',
	copy: 'کپی',
	editAccessLevel: 'ویرایش سطوح دسترسی',
	editRole: 'ویرایش نقش',
	newGroup: 'گروه جدید',
	newDocument: 'مدرک جدید',
	admin: 'مدیر سیستم',
	edit: 'ویرایش',
	delete: 'حذف',
	show: 'نمایش',
	located: 'قرار دارد',
	notLocated: 'قرار ندارد',
	fileInvalidType: 'نوع فایل نامعتبر است',
	fileInvalidTypeDescription: 'نوع فایل باید {{field}} باشد.',
	fileTooLarge: 'فایل خیلی بزرگ است',
	fileInvalidSizeDescription: 'حجم فایل نباید بزرگتر از {{field}} مگابایت باشد.',
	thereIsNoItemToDisplay: 'موردی جهت نمایش وجود ندارد',
	required: '{{field}} را وارد کنید',
	persian: '{{field}} باید فارسی باشد',
	min: '{{field}} نمیتواند کمتر از {{min}} کاراکتر باشد',
	minDigit: '{{field}} نمیتواند کمتر از {{min}} رقم باشد',
	minNumber: '{{field}} نمیتواند کمتر از {{min}} باشد',
	max: '{{field}} نمیتواند بیشتر از {{max}} کاراکتر باشد',
	maxDigit: '{{field}} نمیتواند بیشتر از {{max}} رقم باشد',
	maxNumber: '{{field}} نمیتواند بیشتر از {{max}} باشد',
	length: '{{field}} باید {{length}} کاراکتر باشد',
	inValid: '{{field}} معتبر نیست',
	formatOfPhone: '{{field}} باید در قالب 12345678-021 باشد',
	maximumFileSize: 'حداکثر حجم فایل: {{field}} مگابایت',
	investment: 'سرمایه‌گذاری',
	step: 'مرحله',
	// RequestInfo FieldGroup :
	requestInfo: 'اطلاعات درخواست',
	creationDateTime: 'تاریخ درخواست',
	folderNumber: 'شماره پرونده',
	applicantName: 'نام متقاضی',
	applicantId: 'شناسه/کد ملی متقاضی',
	startupName: 'نام استارتاپ',
	introducerName: 'نام معرف',
	amountOfCapitalRequired: 'مبلغ سرمایه مورد نیاز',
	classingInvestRequired: 'طبقه بندی سرمایه مورد نیاز',
	theAmountOfInvestmentOfTheProjectFounders: 'میزان سرمایه گذاری بنیان گذاران طرح',
	approvedAmount: 'مبلغ مصوب شده',
	description: 'توضیحات',
	introductionLetter: 'نامه معرف',
	introductionLetterUploaderTitle: 'بارگذاری نامه معرف',
	introductionLetterDescription: 'در اینجا نامه معرف را بارگذاری نمایید.',
	// InvestmentMethod FieldGroup :
	investmentModelAndSalesEstimate: 'مدل سرمایه‌گذاری و برآورد فروش',
	percentageOfTransferableSharesForTheAmountOfInvestment: 'درصد سهام قابل واگذاری در ازای مبلغ سرمایه‌گذاری',
	participationModel: 'مدل مشارکت (میزان سرمایه لازم و درصد سهام واگذاری)',
	investorParticipationModel: 'مدل مشارکت سرمایه گذار',
	whatAreTheAdvantagesOfYourProductOverCompetitors: 'مزیت های محصول خود نسبت به رقبا چیست ؟',
	requireField:'پر کردن فیلد الزامی می‌باشد',
	chooseDocumentGroup:'انتخاب گروه مدارک',
	serviceDeskMessage : 'با توجه به نوع درخواست گروه مدارک مورد نظر انتخاب و تنظیمات را اعمال نمایید.',
	folder: 'پرونده',
	person:'شخص',
	require:'اجباری',
	sampleFile: 'فایل نمونه',
	deleteDocument: 'حذف مدرک',
	deleteDescription :'آیا از حذف',
	haveSure :'اطمینان دارید',


};
export default fa;
